module.exports = __webpack_public_path__ + "img/process.9372d2ac.png";